import { errorMsg } from '../../utils/errorMsg';
import React, { useState, useEffect } from 'react';
import { Container, Grid, Card, CardContent, Typography, CircularProgress, Alert, Box } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Pie, Bar } from 'react-chartjs-2';
import api from '../../axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContextNavBar from '../../components/ContextNavBar';
import ModuleHeader from '../../components/ModuleHeader';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

function DashboardCursos() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  const carregar = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await api.get('/cursos/dashboard/estatisticas');
      setStats(res.data);
    } catch (err) {
      setErro(errorMsg(err) || 'Erro ao carregar');
    }
    setLoading(false);
  };

  useEffect(() => { carregar(); }, []);

  if (loading) return <><Header /><ContextNavBar context="cursos" /><Container sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 }, textAlign: 'center' }}><CircularProgress /></Container><Footer /></>;
  if (erro) return <><Header /><ContextNavBar context="cursos" /><Container sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}><Alert severity="error">{erro}</Alert></Container><Footer /></>;
  if (!stats) return null;

  const pieData = {
    labels: ['Ativos', 'Concluídos', 'Rascunhos'],
    datasets: [{
      data: [stats.cursos.ativos, stats.cursos.concluidos, stats.cursos.rascunhos],
      backgroundColor: ['#22c55e', '#3b82f6', '#9ca3af'],
    }],
  };

  const barData = {
    labels: stats.cursos_por_ministerio.map(m => m.ministerio),
    datasets: [{
      label: 'Cursos',
      data: stats.cursos_por_ministerio.map(m => m.total),
      backgroundColor: '#00F1A7',
    }],
  };

  return (
    <>
      <Header />
      <ContextNavBar context="cursos" />
      <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 800, fontSize: { xs: '1.2rem', md: '1.5rem' } }}>Dashboard de Cursos</Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent sx={{ textAlign: 'center' }}>
            <Typography variant="h3" sx={{ fontWeight: 800, color: '#1C1C1E' }}>{stats.cursos.total}</Typography>
            <Typography variant="body2" color="text.secondary">Total de Cursos</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent sx={{ textAlign: 'center' }}>
            <Typography variant="h3" sx={{ fontWeight: 800, color: '#22c55e' }}>{stats.cursos.ativos}</Typography>
            <Typography variant="body2" color="text.secondary">Cursos Ativos</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent sx={{ textAlign: 'center' }}>
            <Typography variant="h3" sx={{ fontWeight: 800, color: '#3b82f6' }}>{stats.inscricoes.total}</Typography>
            <Typography variant="body2" color="text.secondary">Inscrições</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent sx={{ textAlign: 'center' }}>
            <Typography variant="h3" sx={{ fontWeight: 800, color: '#00F1A7' }}>{stats.presencas.taxa}%</Typography>
            <Typography variant="body2" color="text.secondary">Presença Média</Typography>
          </CardContent></Card>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card><CardContent>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>Status dos Cursos</Typography>
            <Box sx={{ maxWidth: 300, mx: 'auto' }}>
              <Pie data={pieData} />
            </Box>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card><CardContent>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>Cursos por Ministério</Typography>
            <Bar data={barData} options={{ responsive: true, plugins: { legend: { display: false } } }} />
          </CardContent></Card>
        </Grid>
      </Grid>
    </Container>
      <Footer />
    </>
  );
}

export default DashboardCursos;
